import { render } from "./SchedulePhotographerShortenedName.vue?vue&type=template&id=bee3e780"
import script from "./SchedulePhotographerShortenedName.vue?vue&type=script&lang=js"
export * from "./SchedulePhotographerShortenedName.vue?vue&type=script&lang=js"

import exportComponent from "/home/xs551928/niidaphoto.com/oyadori/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__